import { CompetencyMapQuestionsQuery, Exact, Scalars } from "@generated/graphql";
import { Stack } from "@mui/material";
import { ApolloQueryResult } from "@apollo/client";
import EmptyList from "components/EmptyList";
import Question from "./Question";

type Question = {
  competencyTitle: string;
  knowledgeBlockTitle: string;
  skillTitle: string;
} & NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<CompetencyMapQuestionsQuery["competencyMap"]>["competences"]
      >[number]["knowledgeBlockCompetences"]
    >[number]["knowledgeBlock"]["skills"]
  >[number]["questions"]
>[number];

interface QuestionsListProps {
  competencyMap: CompetencyMapQuestionsQuery["competencyMap"];
  refetchCompetencyMapQuestions: (
    variables?:
      | Partial<
          Exact<{
            competencyMapId: Scalars["ID"]["input"];
          }>
        >
      | undefined
  ) => Promise<ApolloQueryResult<CompetencyMapQuestionsQuery>>;
}

const QuestionsList = ({ competencyMap, refetchCompetencyMapQuestions }: QuestionsListProps) => {
  const extractQuestions = () => {
    const questions: Question[] = [];

    competencyMap?.competences?.forEach((competence) => {
      competence.knowledgeBlockCompetences?.forEach(({ knowledgeBlock }) => {
        knowledgeBlock.skills?.forEach((skill) => {
          skill.questions?.forEach((question) => {
            questions.push({
              ...question,
              competencyTitle: competence.title,
              knowledgeBlockTitle: knowledgeBlock.title,
              skillTitle: skill.title,
            });
          });
        });
      });
    });

    return questions;
  };

  const questions = extractQuestions();

  if (!questions.length) {
    return <EmptyList emptyPlaceholderText='Пока нет вопросов' />;
  }

  return (
    <Stack spacing={1.5}>
      {competencyMap &&
        questions?.map((question) => (
          <Question
            key={question.id}
            question={question}
            competencyMapId={competencyMap.id}
            competencyTitle={question.competencyTitle}
            knowledgeBlockTitle={question.knowledgeBlockTitle}
            skillTitle={question.skillTitle}
            refetch={refetchCompetencyMapQuestions}
          />
        ))}
    </Stack>
  );
};

export default QuestionsList;
